const DEFAULT_API_BASE_URL = 'https://api.scoutlytics.gg';

export function getApiBaseUrl(): string {
  return process.env.REACT_APP_API_URL || DEFAULT_API_BASE_URL;
}

export function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return fetch(`${getApiBaseUrl()}${normalizedPath}`, {
    cache: 'no-store',
    ...init,
    credentials: 'include',
  });
}

export type ReportAccessState = 'auth' | 'forbidden' | 'not_found' | null;

export function classifyReportAccessStatus(status: number): ReportAccessState {
  if (status === 401) return 'auth';
  if (status === 403) return 'forbidden';
  if (status === 404) return 'not_found';
  return null;
}

export async function readApiErrorMessage(response: Response): Promise<string | undefined> {
  try {
    const body = await response.json();
    if (typeof body?.message === 'string') return body.message;
    if (typeof body?.error === 'string') return body.error;
  } catch {
    // ignore parse errors
  }
  return undefined;
}
